<template>
  <div class="animation" ref="top" :style="getTopStyle()">
    <div class="station_wrapper">
      <div class="image_element sun" ref="sun" v-show="prepared"></div>

      <div class="image_element cloud" ref="cloud0" v-show="prepared && cloudAnimationHandler[0]"></div>
      <div class="image_element cloud" ref="cloud1" v-show="prepared && cloudAnimationHandler[1]"></div>
      <div class="image_element cloud" ref="cloud2" v-show="prepared && cloudAnimationHandler[2]"></div>
      <div class="image_element cloud" ref="cloud3" v-show="prepared && cloudAnimationHandler[3]"></div>
      <div class="image_element cloud" ref="cloud4" v-show="prepared && cloudAnimationHandler[4]"></div>

      <div class="image_element building"></div>

      <div class="image_element clock">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 160 160">
          <circle cx="80" cy="80" r="78"/>
          <line x1="80" y1="80" x2="80" y2="45" ref="clockHourHand"></line>
          <line x1="80" y1="80" x2="80" y2="35" ref="clockMinuteHand"></line>
        </svg>
      </div>

      <div class="image_element tree slim t1">
        <div class="image_element crown"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 82.4 192.13"><path :fill="tree_crown_color" d="M41.21,192.13S0,149.13,0,96.08,41.19,0,41.19,0,82.39,43,82.4,96.05,41.21,192.13,41.21,192.13Z"/></svg></div>
        <div class="image_element trunk"></div>
        <div class="image_element leaves" v-show="trees[0].enabled"><div v-for="i in leavesAmount" class="leaf" :class="{fall: trees[0].falling}" ref="leaf0"></div></div>
      </div>

      <div class="image_element tree slim t2">
        <div class="image_element crown"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 82.4 192.13"><path :fill="tree_crown_color" d="M41.21,192.13S0,149.13,0,96.08,41.19,0,41.19,0,82.39,43,82.4,96.05,41.21,192.13,41.21,192.13Z"/></svg></div>
        <div class="image_element trunk"></div>
        <div class="image_element leaves" v-show="trees[1].enabled"><div v-for="i in leavesAmount" class="leaf" :class="{fall: trees[1].falling}" ref="leaf1"></div></div>
      </div>

      <div class="image_element tree t3">
        <div class="image_element crown"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 151.56 151.56"><circle :fill="tree_crown_color" class="cls-1" cx="75.78" cy="75.78" r="75.78"/></svg></div>
        <div class="image_element trunk"></div>
        <div class="image_element leaves" v-show="trees[2].enabled"><div v-for="i in leavesAmount" class="leaf" :class="{fall: trees[2].falling}" ref="leaf2"></div></div>
      </div>

      <div class="image_element tree t4">
        <div class="image_element crown"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 151.56 151.56"><circle :fill="tree_crown_color" class="cls-1" cx="75.78" cy="75.78" r="75.78"/></svg></div>
        <div class="image_element trunk"></div>
        <div class="image_element leaves" v-show="trees[3].enabled"><div v-for="i in leavesAmount" class="leaf" :class="{fall: trees[3].falling}" ref="leaf3"></div></div>
      </div>

      <div class="image_element people p1" :class="{enabled: people[0].enabled, small: people[0].small}" ref="people0">
        <div class="image_element talk" :class="{left: people[0].left, right: people[0].right}"></div>
      </div>

      <div class="image_element people p2" :class="{enabled: people[1].enabled, small: people[1].small}" ref="people1">
        <div class="image_element talk" :class="{left: people[1].left, right: people[1].right}"></div>
      </div>

      <div class="image_element people p3" :class="{enabled: people[2].enabled, small: people[2].small}" ref="people2">
        <div class="image_element talk" :class="{left: people[2].left, right: people[2].right}"></div>
      </div>

      <div class="image_element people p4" :class="{enabled: people[3].enabled, small: people[3].small}" ref="people3">
        <div class="image_element talk" :class="{left: people[3].left, right: people[3].right}"></div>
      </div>

      <div class="image_element people p5" :class="{enabled: people[4].enabled, small: people[4].small}" ref="people4">
        <div class="image_element talk" :class="{left: people[4].left, right: people[4].right}"></div>
      </div>

      <div class="image_element people p6" :class="{enabled: people[5].enabled, small: people[5].small}" ref="people5">
        <div class="image_element talk" :class="{left: people[5].left, right: people[5].right}"></div>
      </div>

      <div class="image_element traffic">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 121 277">
          <line class="contour" x1="60.5" y1="141.5" x2="60.5" y2="275.66"/>
          <g class="light">
            <rect class="contour" x="28.41" y="1" width="64.18" height="140.62" rx="32" ry="32"/>
            <circle class="sign upper" :class="{green: train_on_station && ! trainIsHidden}" cx="60.5" cy="43.41" r="17.87"/>
            <circle class="sign lower" cx="60.5" cy="95.21" r="17.87"/>
          </g>
          <g class="arrow">
            <rect class="cls-2" x="0.5" y="20.31" width="120" height="120"/>
            <path class="cls-3" d="M113.5,80.31,51.36,34.76v28H7.84L7.5,96.29H51.36v29.57Z"/>
            <path class="cls-4" d="M104.05,80.34,56.57,45.52V66.94H7.8L7.5,92.56H56.57v22.61Z"/>
          </g>
        </svg>
      </div>

      <div class="railway"></div>

      <div class="image_element train" ref="train" v-show="prepared && ! trainIsHidden"></div>
      <div class="image_element train_tonnel left" v-show="prepared && ! trainIsHidden && ! tonnelIsHidden"></div>
      <div class="image_element train_tonnel right" v-show="prepared && ! trainIsHidden && ! tonnelIsHidden"></div>
    </div>
  </div>
</template>

<script>
  import {COUNTDOWN_FINAL_DATE} from "../../../cms/server/app/abstract/constants_project";
  import { TweenLite, Power4} from 'gsap/TweenLite';
  import {Sine, SlowMo} from 'gsap/EasePack';

  const STAGE_INITIAL = 0;
  const STAGE_PROGRESS = 1;

  export default {
    name: 'Animation',

    data () {
      return {
        topHeight: 800,

        timeFactorEnvironment: 3600,
        timeFactorSeasons: 1000000,
        timeFactorCountdown: 3600 * 50,

        prepared: false,

        stage: STAGE_INITIAL,
        startTime: this.$moment(new Date(COUNTDOWN_FINAL_DATE)).add(-3, 'y'),
        targetTime: this.$moment(new Date(COUNTDOWN_FINAL_DATE)),
        startRealTime: this.$moment(),
        stationTime: this.$moment(),
        seasonTime: this.$moment(),
        environmentTime: this.$moment(),

        sunDistanceX: 500,
        sunDistanceY: 400,
        sunDistanceYearDeclination: 20,

        cloudHeightMin: -75,
        cloudHeightMax: -15,
        cloudSpeedMin: 1,
        cloudSpeedMax: 20,
        cloudIntervalSecondsMin: 2,
        cloudIntervalSecondsMax: 15,
        cloudAnimationHandler: [null, null, null, null, null],

        crown_lime: {r:0x0D, g:0xDB, b:0x40},
        crown_green: {r:0x23, g:0xFF, b:0x20},
        crown_yellow: {r:0xFF, g:0xF3, b:0x00},
        crown_orange: {r:0xFF, g:0x89, b:0x00},
        crown_brown: {r:0x4D, g:0x31, b:0x2D},
        tree_crown_color: '#ff8900ff',

        people: [{}, {}, {}, {}, {}, {}],
        peoplePairIntervalSecondsMin: 2,
        peoplePairIntervalSecondsMax: 5,
        peoplePairDurationSecondsMin: 0,
        peoplePairDurationSecondsMax: 15,
        peopleAppearanceProbability: .75,
        peopleChildrenProbability: .33,
        peoplePairsAnimationHandler: [null, null, null],

        train_on_station: false,
        trainIntervalSecondsMin: 2,
        trainIntervalSecondsMax: 5,
        trainMovementDuration: 2,
        trainWaitingOnStation: 4,
        trainAnimationHandler: null,
        trainIsHidden: false,
        tonnelIsHidden: false,

        leavesAmount: 10,
        trees: [
          {enabled: false, falling: false, slim: true, leaves: []},
          {enabled: false, falling: false, slim: true, leaves: []},
          {enabled: false, falling: false, slim: false, leaves: []},
          {enabled: false, falling: false, slim: false, leaves: []},
        ],
      }
    },

    async mounted() {
      window.addEventListener('resize', this.resize);
      await this.resize();
      this.startTime = this.$moment(this.targetTime).add(-3, 'y');
      await this.$forceUpdate();
      await this.$nextTick();
      this.doActive();
    },

    methods: {
      async resize() {
        if (this.$refs.top) {
          this.topHeight = (this.$refs.top.clientWidth * .55) + 'px';
        }
      },

      getTopStyle() {
        return {height: this.topHeight};
      },

      refresh() {
        // time speed
        let secondsPassed = 0;
        secondsPassed = this.$moment().diff(this.startRealTime, 'milliseconds');
        this.stationTime = this.$moment(this.startTime).add(secondsPassed * this.timeFactorCountdown, 'milliseconds');
        this.seasonTime = this.$moment(this.startTime).add(secondsPassed * this.timeFactorSeasons, 'milliseconds');
        this.environmentTime = this.$moment(this.startTime).add(secondsPassed * this.timeFactorEnvironment, 'milliseconds');
        // refresh
        this.clockRefresh();
        this.eclipticRotation();
        this.treeRotation();
      },

      clockRefresh() {
        let hoursAngle = 360 * this.environmentTime.hours() / 12 + this.environmentTime.minute() / 2;
        let minuteAngle = 360 * this.environmentTime.minutes() / 60;
        hoursAngle = hoursAngle % 360;
        minuteAngle = minuteAngle % 360;
        if (this.$refs.clockHourHand) {
          this.$refs.clockHourHand.style.transform = 'rotate(' + hoursAngle + 'deg)';
          this.$refs.clockMinuteHand.style.transform = 'rotate(' + minuteAngle + 'deg)';
        }
      },

      eclipticRotation() {
        let sunriseTime = this.$moment(this.environmentTime).add(6, 'hours');
        let sunriseTimeBySeason = this.$moment(this.stationTime).add(6, 'hours');
        let sunAngle = Math.PI * 2 * (sunriseTime.hours() * 60 + sunriseTime.minute()) / (24 * 60);
        let shiftX = this.sunDistanceX * Math.cos(sunAngle);
        let declination = this.sunDistanceYearDeclination;
        if (sunriseTimeBySeason.dayOfYear() <= 183) {
          declination *= 1 - sunriseTimeBySeason.dayOfYear() / 183;
        } else {
          declination *= (sunriseTimeBySeason.dayOfYear() - 183) / 183;
        }
        let shiftY = declination + this.sunDistanceY * Math.sin(sunAngle);
        if (this.$refs.sun) {
          this.$refs.sun.style['transform'] = 'translate(' + shiftX + '%,' + shiftY + '%)';
          if (shiftY < 200) {
            this.$refs.sun.style['opacity'] = 1;
          } else {
            this.$refs.sun.style['opacity'] = 0;
          }
        }
      },

      async treeRotation() {
        let fromR, toR, fromG, toG, fromB, toB, fromOp, toOp, factor;
        // crown color according to season
        if (this.seasonTime.dayOfYear() < 137) {
          fromR = this.crown_lime.r;
          fromG = this.crown_lime.g;
          fromB = this.crown_lime.b;
          toR = this.crown_lime.r;
          toG = this.crown_lime.g;
          toB = this.crown_lime.b;
          fromOp = 0;
          toOp = 0;
          factor = 1;
        } else if (this.seasonTime.dayOfYear() >= 137 && this.seasonTime.dayOfYear() < 168) {
          fromR = this.crown_lime.r;
          fromG = this.crown_lime.g;
          fromB = this.crown_lime.b;
          toR = this.crown_lime.r;
          toG = this.crown_lime.g;
          toB = this.crown_lime.b;
          fromOp = 0;
          toOp = 255;
          factor = (this.seasonTime.dayOfYear() - 137) / (168 - 137);
        } else if (this.seasonTime.dayOfYear() >= 168 && this.seasonTime.dayOfYear() < 215) {
          fromR = this.crown_lime.r;
          fromG = this.crown_lime.g;
          fromB = this.crown_lime.b;
          toR = this.crown_green.r;
          toG = this.crown_green.g;
          toB = this.crown_green.b;
          fromOp = 255;
          toOp = 255;
          factor = (this.seasonTime.dayOfYear() - 168) / (215 - 168);
        } else if (this.seasonTime.dayOfYear() >= 215 && this.seasonTime.dayOfYear() < 306) {
          fromR = this.crown_green.r;
          fromG = this.crown_green.g;
          fromB = this.crown_green.b;
          toR = this.crown_yellow.r;
          toG = this.crown_yellow.g;
          toB = this.crown_yellow.b;
          fromOp = 255;
          toOp = 255;
          factor = (this.seasonTime.dayOfYear() - 215) / (306 - 215);
        } else if (this.seasonTime.dayOfYear() >= 306 && this.seasonTime.dayOfYear() < 320) {
          fromR = this.crown_yellow.r;
          fromG = this.crown_yellow.g;
          fromB = this.crown_yellow.b;
          toR = this.crown_orange.r;
          toG = this.crown_orange.g;
          toB = this.crown_orange.b;
          fromOp = 255;
          toOp = 255;
          factor = (this.seasonTime.dayOfYear() - 306) / (320 - 306);
        } else if (this.seasonTime.dayOfYear() >= 320 && this.seasonTime.dayOfYear() < 350) {
          fromR = this.crown_orange.r;
          fromG = this.crown_orange.g;
          fromB = this.crown_orange.b;
          toR = this.crown_brown.r;
          toG = this.crown_brown.g;
          toB = this.crown_brown.b;
          fromOp = 255;
          toOp = 0;
          factor = (this.seasonTime.dayOfYear() - 320) / (350 - 320);
        } else {
          fromR = this.crown_brown.r;
          fromG = this.crown_brown.g;
          fromB = this.crown_brown.b;
          toR = this.crown_brown.r;
          toG = this.crown_brown.g;
          toB = this.crown_brown.b;
          fromOp = 0;
          toOp = 0;
          factor = 1;
        }
        this.tree_crown_color = '#' + this.dec2hex(fromR + (toR - fromR) * factor) + this.dec2hex(fromG + (toG - fromG) * factor) + this.dec2hex(fromB + (toB - fromB) * factor) + this.dec2hex(fromOp + (toOp - fromOp) * factor);
        // появление и сбрасывание листьев осенью
        let leavesDay = 335;
        if (this.seasonTime.dayOfYear() >= leavesDay) {
          // generate leaves and show
          let needRefresh = false;
          for (let li in this.trees) {
            let l = this.trees[li];
            if (! l.enabled) {
              needRefresh = true;
              // first leaves appearance at the later autumn
              for (let i = 0; i < this.leavesAmount; i ++) {
                let minX = -25, minY = -10, maxX = 25, maxY = 10;
                let leafData = {
                  x: minX + Math.random() * maxX * 2,
                  y: minY + Math.random() * maxY * 2,
                };
                l.leaves.push(leafData);
              }
              l.enabled = true;
              await this.$forceUpdate();
              let elements = this.$refs['leaf' + li];
              for (let ei in elements) {
                let leafElement = elements[ei];
                let leafData = l.leaves[ei];
                if (leafElement && leafData) {
                  leafElement.style.left = 45 + leafData.x + '%';
                  leafElement.style.top = (50 + leafData.y) + '%';
                }
              }
            }
          }
          if (needRefresh) {
            setTimeout(() => {
              for (let l of this.trees) {
                l.falling = true;
              }
            }, 50);
          }
        } else {
          // hide leaves
          for (let l of this.trees) {
            l.enabled = false;
            l.falling = false;
            l.leaves = [];
          }
        }
      },

      dec2hex(value) {
        return ('0' + (Number(Math.floor(value)).toString(16))).slice(-2).toUpperCase();
      },

      weatherRotation(index) {
        let duration = Math.random() * this.cloudSpeedMin + (this.cloudSpeedMax - this.cloudSpeedMin);
        // let delaySeconds = Math.random() * this.cloudIntervalSecondsMin + (this.cloudIntervalSecondsMax - this.cloudIntervalSecondsMin);
        let cloudHeight = Math.random() * this.cloudHeightMin + (this.cloudHeightMax - this.cloudHeightMin);
        let m = this.stationTime.month();
        if (m >= 5 && m <= 7) {
          this.$refs['cloud' + index].style['opacity'] = 0;
        } else if (m > 7 && m <= 10) {
          this.$refs['cloud' + index].style['opacity'] = 1;
        } else {
          this.$refs['cloud' + index].style['opacity'] = Math.random() < 0.5 ? 1 : 0;
        }
        let obj = {
          index: index,
          element: this.$refs['cloud' + index],
          height: cloudHeight,
          position: -20,
          owner: this,
        };
        this.cloudAnimationHandler[index] = TweenLite.to(
          obj,
          duration, {
            position: 1500,
            //delay: delaySeconds,
            ease: 'linear',
            onUpdate: function() {
              this.target.element.style['transform'] = 'translate(' + this.target.position + '%, ' + this.target.height + '%)';
            },
            onComplete: function() {
              if (this.target.owner.stage == STAGE_PROGRESS) {
                this.target.owner.weatherRotation(this.target.index);
              }
            },
          },
        );
      },

      peoplePairRotation(pairIndex) {
        // pair
        this.people[pairIndex * 2] = {
          enabled: Math.random() < this.peopleAppearanceProbability,
          small: Math.random() < this.peopleChildrenProbability,
          talkStage: 0,
          left: false,
          right: false,
        };
        this.people[pairIndex * 2 + 1] = {
          enabled: Math.random() < this.peopleAppearanceProbability,
          small: Math.random() < this.peopleChildrenProbability,
          talkStage: 0,
          left: false,
          right: false,
        };
        let duration = Math.floor(Math.random() * (this.peoplePairDurationSecondsMin + (this.peoplePairDurationSecondsMax - this.peoplePairDurationSecondsMin)));
        // people appearance or delayed request for generation
        this.$forceUpdate();
        if (duration > 0 && (this.people[pairIndex * 2].enabled || this.people[pairIndex * 2 + 1].enabled)) {
          //let delaySeconds = Math.random() * (this.peoplePairIntervalSecondsMin + (this.peoplePairIntervalSecondsMax - this.peoplePairIntervalSecondsMin));
          let obj = {
            pairIndex: pairIndex,
            progress: 0,
            owner: this,
          };
          this.peoplePairsAnimationHandler[pairIndex] = TweenLite.to(
            obj,
            duration, {
              progress: 400,
              //delay: delaySeconds,
              ease: 'linear',
              onUpdate: async function() {
                // toggle talking signs
                if (this.target.owner.people[this.target.pairIndex * 2].enabled && this.target.owner.people[this.target.pairIndex * 2 + 1].enabled) {
                  let signIndex = this.target.progress / 400;
                  let signRight = this.target.owner.people[this.target.pairIndex * 2].right;
                  let signLeft = this.target.owner.people[this.target.pairIndex * 2 + 1].left;
                  let talkStage = 0;
                  if (signIndex >= 0 && signIndex < 0.25) {
                    signRight = true;
                    signLeft = false;
                    talkStage = 0;
                  } else if (signIndex >= 0.25 && signIndex < 0.5) {
                    signRight = false;
                    signLeft = true;
                    talkStage = 1;
                  } else if (signIndex >= 0.5 && signIndex < 0.75) {
                    signRight = true;
                    signLeft = false;
                    talkStage = 2;
                  } else {
                    signRight = false;
                    signLeft = true;
                    talkStage = 3;
                  }
                  if (signRight != this.target.owner.people[this.target.pairIndex * 2].right || signLeft != this.target.owner.people[this.target.pairIndex * 2 + 1].left) {
                    if (this.target.owner.people[this.target.pairIndex * 2].talkStage != talkStage) {
                      this.target.owner.people[this.target.pairIndex * 2].right = Math.random() < 0.5 ? signRight : false;
                      this.target.owner.people[this.target.pairIndex * 2].talkStage = talkStage;
                      this.target.owner.$forceUpdate();
                    }
                    if (this.target.owner.people[this.target.pairIndex * 2 + 1].talkStage != talkStage) {
                      this.target.owner.people[this.target.pairIndex * 2 + 1].left = Math.random() < 0.5 ? signLeft : false;
                      this.target.owner.people[this.target.pairIndex * 2 + 1].talkStage = talkStage;
                      this.target.owner.$forceUpdate();
                    }
                  }
                }
              },
              onComplete: async function() {
                this.target.owner.people[this.target.pairIndex * 2].enabled = false;
                this.target.owner.people[this.target.pairIndex * 2 + 1].enabled = false;
                await this.target.owner.$forceUpdate();
                setTimeout(() => {
                  if (this.target.owner.stage == STAGE_PROGRESS) {
                    this.target.owner.peoplePairRotation(this.target.pairIndex);
                  }
                }, Math.random() * (this.target.owner.peoplePairIntervalSecondsMin + (this.target.owner.peoplePairIntervalSecondsMax - this.target.owner.peoplePairIntervalSecondsMin)) * 1000);
              },
            },
          );
        } else {
          // may be next time
          this.people[pairIndex * 2].enabled = false;
          this.people[pairIndex * 2 + 1].enabled = false;
          this.$forceUpdate();
          setTimeout(() => {
            if (this.stage == STAGE_PROGRESS) {
              this.peoplePairRotation(pairIndex);
            }
          }, Math.random() * (this.peoplePairIntervalSecondsMin + (this.peoplePairIntervalSecondsMax - this.peoplePairIntervalSecondsMin)) * 1000);
        }
      },

      trainRotation(instantFinal = false) {
        // initial state: out of the station beyond the left tonnel, traffic light is red
        this.train_on_station = false;
        if (! this.$refs.train) {
          return;
        }
        this.$refs.train.style['transform'] = 'translateX(0)';
        this.$forceUpdate();
        // prepare and start
        let duration = this.trainMovementDuration;
        let delaySeconds = instantFinal ? 0 : Math.random() * this.trainIntervalSecondsMin + (this.trainIntervalSecondsMax - this.trainIntervalSecondsMin);
        let obj = {
          element: this.$refs.train,
          progress: 0,
          owner: this,
          finalStop: instantFinal,
        };
        this.trainAnimationHandler = TweenLite.to(
          obj,
          duration, {
            progress: 307,
            delay: delaySeconds,
            ease: SlowMo.easeOut,
            onUpdate: function() {
              if (this.target.progress > 50) {
                this.target.owner.train_on_station = true;
              }
              this.target.element.style['transform'] = 'translateX(' + this.target.progress + '%)';
            },
            onComplete: function() {
              if (this.target.finalStop) {
                this.target.owner.cancelAllTweenAnimation();
                this.target.owner.stopTrain(true);
              } else {
                // arrived state: on the station, traffic light is green
                this.target.owner.train_on_station = true;
                this.target.owner.$forceUpdate();
                let obj = {
                  element: this.target.element,
                  progress: 307,
                  owner: this.target.owner,
                };
                this.trainAnimationHandler = TweenLite.to(
                  obj,
                  this.target.owner.trainMovementDuration, {
                    progress: 577,
                    delay: this.target.owner.trainWaitingOnStation,
                    ease: SlowMo.easeIn,
                    onUpdate: function() {
                      if (this.target.progress > 550) {
                        this.target.owner.train_on_station = false;
                      }
                      this.target.element.style['transform'] = 'translateX(' + this.target.progress + '%)';
                    },
                    onComplete: function() {
                      // gone state: out of the station beyond the right tonnel, traffic light is red
                      this.target.owner.train_on_station = false;
                      this.target.owner.$forceUpdate();
                      if (this.target.owner.stage == STAGE_PROGRESS) {
                        this.target.owner.trainRotation();
                      }
                    },
                  },
                );
              }
            },
          },
        );
      },

      frameAnimation() {
        if (this.stage != STAGE_PROGRESS) return;
        if (this.showTimer && this.targetTime.diff(this.stationTime) < 0) {
          this.finish();
          return;
        }
        this.refresh();
       requestAnimationFrame(this.frameAnimation);
      },

      doActive() {
        this.isActive = true;
        setTimeout(() => {
          this.prepared = true;
          this.start();
        }, 100);
      },

      async resetEvolutions () {
        await this.cancelAllTweenAnimation();
        await this.$forceUpdate();
      },

      start() {
        this.stage = STAGE_PROGRESS;
        this.startRealTime = this.$moment();
        this.frameAnimation();
        this.startAllTweenAnimation();
      },

      setSeasonsFasten(value) {
        this.timeFactorSeasons = value ? 1500000 : this.timeFactorCountdown;
      },

      startAllTweenAnimation() {
        // clouds
        for (let i = 0; i < 5; i ++) {
          setTimeout(() => {
            if (this.stage == STAGE_PROGRESS) {
              this.weatherRotation(i);
            }
          }, Math.random() * (this.cloudIntervalSecondsMin + (this.cloudIntervalSecondsMax - this.cloudIntervalSecondsMin)) * 1000);
        }
        // people pairs (talking)
        if (this.stage == STAGE_PROGRESS) {
          this.peoplePairRotation(0);
          this.peoplePairRotation(1);
          this.peoplePairRotation(2);
        }
        // train arrival
        if (this.stage == STAGE_PROGRESS) {
          this.trainRotation();
        }
      },

      async cancelAllTweenAnimation() {
        for (let i in this.cloudAnimationHandler) {
          let h = this.cloudAnimationHandler[i];
          if (h) {
            h.kill();
            h = null;
            this.$refs['cloud' + i].style['opacity'] = 0;
          }
        }
        for (let h of this.peoplePairsAnimationHandler) {
          if (h) {
            h.kill();
            h = null;
          }
        }
        this.stopTrain();
      },

      stopTrain(hideTrain = false) {
        if (this.trainAnimationHandler) {
          this.trainAnimationHandler.kill();
          this.trainAnimationHandler = null;
        }
        if (hideTrain) {
          this.trainIsHidden = hideTrain;
        }
      },

    },

  }
</script>

<style lang="less">
  @ceremony_color_red: #DD0D25;
  @ceremony_color_bg_blue: #000B41;
  @ceremony_color_orange: #FF8900;
  @ceremony_color_yellow: #FFF300;
  @ceremony_color_cyan: #00E1CD;
  @ceremony_color_light_blue: #00AAFF;
  @ceremony_color_blue: #3C00F0;
  @ceremony_color_green: #0DDB40;
  @ceremony_color_dark_blue: #1E285A;
  @ceremony_color_white: #FFFFFF;
  @ceremony_station_appearance_speed: 1000ms;

  .animation {
    position: relative;
    width: 100%;
    height: 100%;

    .hidden {
      display: none;
    }

    .station_wrapper {
      position: relative;
      width: 100%;
      height: 100%;
      overflow: hidden;
    }

    .image_element {
      position: absolute;
      background-repeat: no-repeat;
      &.hidden {
        display: none;
      }
    }

    .sun {
      background-image: url(../../static/sun.svg);
      top: 60%;
      left: 50%;
      width: 13%;
      height: 13%;
    }

    .cloud {
      background-image: url(../../static/cloud.svg);
      top: 15%;
      left: -8%;
      width: 8%;
      height: 9%;
    }

    .building {
      background-image: url(../../static/station.svg);
      top: 30%;
      left: 5%;
      width: 90%;
      height: 100%;
    }

    .clock {
      top: 36%;
      left: 50%;
      width: 6%;
      transform: translateX(-25%);
      height: 6%;
      circle, path, line {
        fill:none;
        stroke: #fff;
        stroke-linecap: square;
        stroke-miterlimit: 10;
        stroke-width: 4.35px;
      }
      line {
        transform-origin: 80px 80px;
      }
    }

    .tree {
      position: absolute;
      top: 40%;
      width: 6%;
      height: 23%;
      display: flex;
      justify-content: center;
      align-items: flex-end;
      .leaves {
        position: absolute;
        width: 100%;
        height: 100%;
      }
      &.t1 {
        left: 4%;
      }
      &.t2 {
        left: 25%;
      }
      &.t3 {
        left: 33%;
      }
      &.t4 {
        left: 88%;
      }
      .crown {
        position: relative;
        width: 100%;
        height: 100%;
        top: 28%;
      }
      .trunk {
        background-image: url(../../static/tree-naked.svg);
        background-size: cover;
        height: 67%;
        width: 64%;
      }
      .leaf {
        position: absolute;
        background-image: url(../../static/leaf.svg);
        background-size: cover;
        width: 12%;
        height: 6%;
        top: 55%;
        left: 45%;
        transition: transform 1500ms ease-in, opacity 250ms ease-out 1500ms;
        &.fall {
          transform: translateY(650%) scale(0) rotate(360deg);
          opacity: 0;
          &:nth-child(even) {
            transform: translateY(650%) scale(0) rotate(-360deg);
          }
        }
      }
      &.slim {
        top: 40%;
        width: 6%;
        height: 23%;
        .crown {
          width: 51%;
          height: 98%;
        }
        .trunk {
          background-image: url(../../static/tree-naked-slim.svg);
          height: 56%;
          width: 33%;
        }
        /*.leaf {*/
        /*  &.fall {*/
        /*    &.fall {*/
        /*      transform: translateY(185px) scale(0) rotate(360deg);*/
        /*      opacity: 0;*/
        /*      &:nth-child(even) {*/
        /*        transform: translateY(185px) scale(0) rotate(-360deg);*/
        /*      }*/
        /*    }*/
        /*  }*/
        /*}*/
      }
    }

    .people {
      background-image: url(../../static/man-big.svg);
      background-size: contain;
      top: 46.5%;
      width: 3.15%;
      height: 17%;
      opacity: 0;
      transition: opacity 250ms ease-in-out;
      &.p1 {
        left: 12%;
      }
      &.p2 {
        left: 21%;
      }
      &.p3 {
        left: 72%;
      }
      &.p4 {
        left: 76%;
      }
      &.p5 {
        left: 80%;
      }
      &.p6 {
        left: 84%;
      }
      &.enabled {
        opacity: 1;
        .talk {
          width: 70%;
          height: 20%;
          opacity: 0;
          transition: opacity 100ms ease-in-out;
          &.left {
            opacity: 1;
            background-image: url(../../static/talk-left.svg);
            margin-left: -50%;
            margin-top: -50%;
          }
          &.right {
            opacity: 1;
            background-image: url(../../static/talk-left.svg);
            margin-left: 85%;
            margin-top: -50%;
            transform: scale(-1, 1);
          }
        }
      }
      &.small {
        background-image: url(../../static/man-small.svg);
        top: 54%;
        height: 10%;
        width: 2.25%;
        &.enabled {
          .talk {
            width: 70%;
            height: 20%;
            &.left {
              background-image: url(../../static/talk-left.svg);
              margin-left: -50%;
              margin-top: -50%;
            }
            &.right {
              background-image: url(../../static/talk-left.svg);
              margin-left: 75%;
              margin-top: -50%;
            }
          }
        }
      }
    }

    .traffic {
      background-size: contain;
      top: 54%;
      right: 2%;
      width: 4%;
      height: 22%;
      transition: transform 500ms;
      svg {
        stroke: #fff;
        stroke-linecap: square;
        stroke-miterlimit: 10;
        stroke-width: 4.35px;
        .light {
          .contour {
            fill: @ceremony_color_bg_blue;
          }
          .sign {
            transition: transform 500ms;
            transform-origin: 50%;
            &.upper {
              fill: @ceremony_color_red;
              transition: fill 250ms ease-in;
              &.green {
                fill: @ceremony_color_green;
              }
            }
            &.lower {
              fill: none;
            }
          }
        }
        .arrow {
          transition: transform 500ms;
          transform: rotateY(90deg);
          transform-origin: 50%;
          .cls-2 {
            fill:blue;stroke:blue;
          }
          .cls-3 {
            fill:#fff;
          }
          .cls-4{
            fill:#f7da06;
          }
        }
      }
      &.big_sign {
        transform: translate(-1383px, -346px) scale(4.5);
      }
      &.as_ertms {
        svg {
          .light {
            transform: rotateY(90deg);
          }
          .arrow {
            transform: rotateY(0deg);
          }
        }
      }
    }

    .railway {
      position: absolute;
      background-repeat: repeat;
      background-image: url(../../static/railroad-fragment.svg);
      top: 72%;
      left: 5%;
      width: 92%;
      height: 4%;
      transition: transform 1500ms ease-in;
    }

    .train {
      background-image: url(../../static/train-solid.svg);
      top: 60%;
      left: -22%;
      width: 21%;
      height: 16%;
      background-size: contain;
    }

    .train_tonnel {
      background-color: @ceremony_color_bg_blue;
      top: 59%;
      width: 4%;
      height: 18%;
      &.left {
        left: 0;
      }
      &.right {
        right: -1.5%;
      }
    }

  }
</style>



// WEBPACK FOOTER //
// src/components/Animation.vue